import { render } from "./OnlineTestsList.vue?vue&type=template&id=6973cfb3"
import script from "./OnlineTestsList.vue?vue&type=script&lang=js"
export * from "./OnlineTestsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__